import styles from './Astafiev.module.scss';
import note from './astafiev/note.png'

export const AudioNote = () => {
    return <div className={styles.note}>
        <img src={note}/>
    </div>
}